import { Box, Card, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../../../Styles/Colors'
import { getCachevalue, localGetItem } from '../../../../../Utility/Services/CacheProviderService'
import { IP_DOC_NOTES_LAYOUT } from '../../../../../Utility/Constants'
import { ActionButton, renderNOData } from '../SarasCommonComp'
import SarasBoldItalic from '../SarasBoldItalic'
import SarasExamination from '../SarasExamination'
import SarasIcdDiagnosis from '../SarasIcdDiagnosis'
import { ImagePaths } from '../../../../../Utility/ImagePaths'
import { Serviceurls } from '../../../../../Utility/API/Serviceurls'
import RestAPIService from '../../../../../Utility/Services/RestAPIService'
import SarasPainScale from '../SarasPainScale'
import SarasPatientCategory from '../SarasPatientCategory'
import SarasReviewPlan from '../SarasReviewPlan'
import SarasClinicExamination from '../SarasClinicExamination'
import SarasObstericData from '../SarasObstericData'
import SarasAllergies from '../SarasAllergies'
import { painLevelTxt } from '../../../../../Utility/Constants';

const getButtonStyle = (isSelected) => ({
    width: "100%",
    color: isSelected ? '#fff' : Colors.SecondaryText,
    borderTop: isSelected ? '1px solid transparent' : 'none',
    borderBottom: isSelected ? '1px solid transparent' : '1px solid #E3E2E2',
    borderRadius: 0,
    textAlign: 'left',
    justifyContent: 'flex-start',
});

const SarasIPDocHome = (props) => {
    const [state, setState] = useState({
        patientDetails: JSON.parse(getCachevalue('IppatientData')),
        loginInfo: JSON.parse(localGetItem('loggedInUserInfo')),
        clinic_id: localGetItem('SelectedDoctorClinicId'),
        DocNotesLayout: [],
        SelectedComponent: null,
        layoutloading: false,
        scrollToIndex: null,
        dynamicState: {},
        hasFetched: null,
        alleryData: [],
        isNewBilling: JSON.parse(localGetItem('isNewBilling')),
        doctorNotesHistory: {},
        is_From_IpNotes: false
    })
    const divRefs = useRef([]);
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    // API STARTS =====>

    useEffect(() => {
        if (state.loginInfo) {
            // getDoctorNotesLayout()
            getIpDoctorNotesHistoryData()
        }
    }, [state.loginInfo])

    const callHistory = (message) => {
        if (message) {
            getIpDoctorNotesHistoryData()
        }
    }

    useEffect(() => {
        if (Object.keys(props?.doctorNotesLayout)?.length) {
            const Doctor_Notes_Layout = JSON.parse(JSON.stringify(IP_DOC_NOTES_LAYOUT));
            const response_data = props?.doctorNotesLayout?.template_data?.length > 0 ? props?.doctorNotesLayout?.template_data : Doctor_Notes_Layout
            updateState({
                DocNotesLayout: response_data,
                SelectedComponent: response_data[0]?.field_name,
                isNewLayout: response_data[0]?.is_new ? response_data[0] : {},
                layoutloading: false,
                is_From_IpNotes: props?.is_From_IpNotes || false
            })
        }
    }, [props?.doctorNotesLayout])

    useEffect(() => {
        if (state.DocNotesLayout.length) {
            const newRefs = [];
            let activeIndex = 0;

            for (let i = 0; i < state.DocNotesLayout.length; i++) {
                if (state.DocNotesLayout[i].is_active) {
                    newRefs[activeIndex] = divRefs.current[activeIndex] ?? React.createRef();
                    activeIndex++;
                }
            }

            divRefs.current = newRefs;
        }
    }, [state.DocNotesLayout]);

    useEffect(() => {
        if (!state.layoutloading && state.DocNotesLayout.length > 0) {
            // Find first active item index
            const firstActiveIndex = state.DocNotesLayout.findIndex(item => item.is_active);
            setState(prev => ({
                ...prev,
                scrollToIndex: firstActiveIndex === -1 ? null : 0, // 0 for first active item in refs
                SelectedComponent: state.DocNotesLayout[firstActiveIndex]?.field_name,
            }));
        }
    }, [state.layoutloading, state.DocNotesLayout]);

    useEffect(() => {
        if (
            state.scrollToIndex !== null &&
            !state.layoutloading &&
            divRefs.current[state.scrollToIndex]?.current
        ) {
            requestAnimationFrame(() => {
                divRefs.current[state.scrollToIndex].current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'center',
                });
            });
        }
    }, [state.scrollToIndex, state.layoutloading, state.DocNotesLayout]);

    useEffect(() => {
        if (state.patientDetails?.id) {
            getNewLayoutData()
        }
    }, [state.patientDetails])

    const generateStatekey = (value) => {
        return value?.replace(/\s+/g, "_")
    }

    const handleDisableTransfer = (flag) => {
        updateState({ TransmitDisable: flag })
    }

    const getNewLayoutData = (forceFetch = "") => {
        try {
            let clinicId = state.patientDetails?.clinic_id ? state.patientDetails?.clinic_id : state.clinic_id
            if (forceFetch && state.hasFetched === forceFetch) return;
            RestAPIService.getAll(Serviceurls.SAR_IP_DOC_NOTES_NEW_LAYOUT_DATA + `?clinic_id=${clinicId}&doctor_id=${state.patientDetails?.doctor_id}&ip_admission_id=${state.patientDetails?.id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const dynamicState = Object.entries(response.data.data).reduce((acc, [key, value]) => {
                            // const stateKey = generateStatekey(key);
                            const stateKey = key;
                            acc[stateKey] = value.comments || "";
                            return acc;
                        }, {});
                        updateState({
                            dynamicState: dynamicState || {},
                            hasFetched: forceFetch,
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getDoctorNotesLayout = () => {
        try {
            updateState({ layoutloading: true })
            const Doctor_Notes_Layout = JSON.parse(JSON.stringify(IP_DOC_NOTES_LAYOUT));
            let clinicId = state.patientDetails?.clinic_id ? state.patientDetails?.clinic_id : state.clinic_id
            RestAPIService.getAll(Serviceurls.SAR_IP_DOC_NOTES_NEW_LAYOUT_CONFIG + `?clinic_id=${clinicId}&doctor_id=${state.patientDetails?.doctor_id}&ip_admission_id=${state.patientDetails?.id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const response_data = response?.data?.data?.template_data?.length > 0 ? response?.data?.data?.template_data : Doctor_Notes_Layout
                        updateState({
                            DocNotesLayout: response_data,
                            SelectedComponent: response_data[0]?.field_name,
                            isNewLayout: response_data[0]?.is_new ? response_data[0] : {},
                            layoutloading: false,
                        })
                    }
                }).catch((error) => {
                    updateState({ layoutloading: false })
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ layoutloading: false })
            errorMessage(error.message)
        }
    }

    const getIpDoctorNotesHistoryData = () => {
        try {
            let clinicId = state.patientDetails?.clinic_id ? state.patientDetails?.clinic_id : state.clinic_id
            RestAPIService.getAll(Serviceurls.SAR_IP_NOTES_HISTORY + `?clinic_id=${clinicId}&doctor_id=${state.patientDetails?.doctor_id}&ip_admission_id=${state.patientDetails?.id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const response_data = response?.data?.data || {}
                        updateState({
                            doctorNotesHistory: response_data
                        })
                    }
                }).catch((error) => {
                    updateState({ layoutloading: false })
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    // API ENDS =======>
    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const renderMenu = () => {
        let activeIndex = 0;
        return (
            <Box width={"100%"} display={"flex"} flexDirection={"column"} alignItems={"flex-start"}>
                <ActionButton
                    text={"Menu"}
                    emed_tid='doc_notes_moveto_option'
                    className='emed_menuItem'
                    variant={'text'}
                    sx={{
                        ...getButtonStyle(false),
                        fontWeight: "bold",
                        borderBottom: "none"
                    }}
                />
                {state.DocNotesLayout?.filter(fil => fil?.is_active)?.map((item, index) => {
                    const isSelected = state.SelectedComponent === item.field_name;
                    return (
                        <ActionButton
                            text={item?.custom_name}
                            emed_tid='doc_notes_moveto_option'
                            className='emed_menuItem'
                            variant={isSelected ? 'contained' : 'text'}
                            sx={getButtonStyle(isSelected)}
                            onClick={() => {
                                updateState({
                                    SelectedComponent: item.field_name,
                                    isNewLayout: item.is_new ? item : {},
                                    scrollToIndex: index
                                })
                            }}
                        />
                    )
                })}
            </Box>
        )
    }

    const setAllergyData = (data) => {
        updateState({ alleryData: [] })
    }

    const renderComponent = (data) => {
        try {
            const { field_name, custom_name, is_new } = data;
            const commonProps = {
                Title: custom_name,
                field_name,
                PatientData: state.patientDetails,
                patientId: state.patientDetails?.patient_id,
                appointmentId: state.patientDetails?.appointment_id || null,
                admission_id: state.patientDetails?.id,
                isSelected: field_name === state.SelectedComponent,
                isLocked: false,
                isCompleted: false,
                errorMessage: errorMessage.bind(this),
                successMessage: successMessage.bind(this),
                clinicId: state.loginInfo?.clinic_id ? state.loginInfo?.clinic_id : +state.clinic_id,
                fromIp: true,
                doctor_id: state?.patientDetails?.doctor_id,
                is_From_IpNotes: state.is_From_IpNotes || false
            };
            switch (field_name) {
                case "pain_scale":
                    return <SarasPainScale {...commonProps} callHistory={callHistory}/>;
                case "patient_category":
                    return <SarasPatientCategory {...commonProps} />;
                case "counselling":
                    return null;
                // return <SarasCounselling {...commonProps}
                //     handleDisableTransfer={handleDisableTransfer.bind(this)} />;
                case "review_plan":
                    return <SarasReviewPlan {...commonProps} callHistory={callHistory}/>;
                case "clinicExam":
                    return <SarasClinicExamination {...commonProps} />;
                case "diagnosis":
                    return <SarasIcdDiagnosis {...commonProps} callHistory={callHistory} />;
                case "examination":
                    return <SarasExamination {...commonProps} callHistory={callHistory} />;
                case "obstetric_data":
                    return <SarasObstericData {...commonProps} />;
                case "allergies":
                    return <SarasAllergies
                        {...commonProps}
                        showAllergyData={setAllergyData.bind(this)}
                        allergyData={state.alleryData || []} 
                        callHistory={callHistory}/>;
                case "clinical_history":
                case "past_history":
                    return null;
                default:
                    return <SarasBoldItalic
                        {...commonProps}
                        stateValue={state.dynamicState[field_name] || ""}
                        GetAPiCall={(data) => getNewLayoutData(data)}
                        systemName={field_name}
                        setAllergyData={setAllergyData.bind(this)}
                        isNewLayout={Boolean(is_new)}
                        callHistory={callHistory}
                    />
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderHistoryDetails = (item) => {
        try {
            let modified_by = item?.modified_by || item?.created_by || '-'
            let time = item?.modified_date || '-'
            return (
                <Box component={'div'} borderBottom={'1.5px solid lightgray'}>
                    <Box component={'div'}>
                        <Box component={'div'} display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                            <Box component={'img'} src={ImagePaths.Doctor_Icon.default} alt='' height={'3dvh'} width={'1.2dvw'} sx={{ mr: '0.5rem' }} />
                            {modified_by?.length > 15 ? <Tooltip placement='top' modified_by={modified_by}><Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{modified_by?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{modified_by}</Typography>}
                            <Box display={'flex'} alignItems={'center'}>
                                <Box component={'img'} src={ImagePaths.Clock.default} alt='' height={'3dvh'} width={'1.2dvw'} sx={{ mr: '0.5rem' }} />
                                {time?.length > 25 ? <Tooltip placement='top' title={time}><Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{time?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{time}</Typography>}
                            </Box>
                        </Box>
                        <Box component={'div'} mb={'0.5rem'}>
                            {item?.notes_type === 'examination' && item?.exam_data?.length > 0 ?
                                <><Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Previous Examination</Typography></Box>
                                    <Box component={'div'} border={'1px solid lightgray'}>
                                        <Table size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Exam Name</TableCell>
                                                    <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Signs</TableCell>
                                                    <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Notes</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item?.exam_data?.map((exam, index) => {
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell>{exam?.exam_name ? exam?.exam_name?.length > 10 ?
                                                                <Tooltip placement='top' title={exam?.exam_name}><Typography fontSize={'0.9rem'}>{exam?.exam_name?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                <Typography fontSize={'0.9rem'}>{exam?.exam_name}</Typography> : '-'}</TableCell>
                                                            <TableCell>{exam?.signs ? exam?.signs?.length > 10 ?
                                                                <Tooltip placement='top' title={exam?.signs}><Typography fontSize={'0.9rem'}>{exam?.signs?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                <Typography fontSize={'0.9rem'}>{exam?.signs}</Typography> : '-'}</TableCell>
                                                            <TableCell>{exam?.description ? exam?.description?.length > 10 ?
                                                                <Tooltip placement='top' title={exam?.description}><Typography fontSize={'0.9rem'}>{exam?.description?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                <Typography fontSize={'0.9rem'}>{exam?.description}</Typography> : '-'}</TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </Box></> :
                                item?.notes_type === 'diagnosis' && item?.dia_data?.length > 0 ?
                                    <><Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Previous Diagnosis</Typography></Box>
                                        <Box component={'div'} border={'1px solid lightgray'}>
                                            <Table size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>ICD Code</TableCell>
                                                        <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Short Descp.</TableCell>
                                                        <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Long Descp.</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {item?.dia_data?.map((dia, index) => {
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell>{dia?.icd_code ? dia?.icd_code?.length > 10 ?
                                                                    <Tooltip placement='top' title={dia?.icd_code}><Typography fontSize={'0.9rem'}>{dia?.icd_code?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                    <Typography fontSize={'0.9rem'}>{dia?.icd_code}</Typography> : '-'}</TableCell>
                                                                <TableCell>{dia?.icd_short_desc ? dia?.icd_short_desc?.length > 10 ?
                                                                    <Tooltip placement='top' title={dia?.icd_short_desc}><Typography fontSize={'0.9rem'}>{dia?.icd_short_desc?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                    <Typography fontSize={'0.9rem'}>{dia?.icd_short_desc}</Typography> : '-'}</TableCell>
                                                                <TableCell>{dia?.icd_long_desc ? dia?.icd_long_desc?.length > 10 ?
                                                                    <Tooltip placement='top' title={dia?.icd_long_desc}><Typography fontSize={'0.9rem'}>{dia?.icd_long_desc?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                    <Typography fontSize={'0.9rem'}>{dia?.icd_long_desc}</Typography> : '-'}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </Box></> :
                                    item?.notes_type === 'allergies' && item?.allergy_data?.length > 0 ?
                                        <><Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Previous Allergies</Typography></Box>
                                            <Box component={'div'} border={'1px solid lightgray'}>
                                                <Table size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Allergy Name</TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Status</TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Comments</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {item?.allergy_data?.map((aller, index) => {
                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell>{aller?.name ? aller?.name?.length > 10 ?
                                                                        <Tooltip placement='top' title={aller?.name}><Typography fontSize={'0.9rem'}>{aller?.name?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                        <Typography fontSize={'0.9rem'}>{aller?.name}</Typography> : '-'}</TableCell>
                                                                    <TableCell><Typography fontSize={'0.9rem'}>{aller?.status == true ? "Active" : "In Active"}</Typography></TableCell>
                                                                    <TableCell>{aller?.comments ? aller?.comments?.length > 1 ?
                                                                        <Tooltip placement='top' title={aller?.comments}><Typography fontSize={'0.9rem'}>{aller?.comments?.slice(0, 14) + '...'}</Typography></Tooltip> :
                                                                        <Typography fontSize={'0.9rem'}>{aller?.comments}</Typography> : '-'}</TableCell>
                                                                </TableRow>
                                                            )
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </Box></> :
                                        item?.notes_type === 'review_plan' && item?.review_data?.length > 0 ?
                                            <><Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Previous Review Plan</Typography></Box>
                                                <Box component={'div'} border={'1px solid lightgray'}>
                                                    <Table size='small'>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Duration</TableCell>
                                                                <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Review Date</TableCell>
                                                                <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9rem', fontWeight: 600 }}>Comments</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {item?.review_data?.map((rev, index) => {
                                                                return (
                                                                    <TableRow key={index}>
                                                                        <TableCell>
                                                                            <Typography fontSize={'0.9rem'}>{rev?.duration + "-" + rev?.duration_type}</Typography></TableCell>
                                                                        <TableCell>
                                                                            <Typography fontSize={'0.9rem'}>{rev?.review_date}</Typography></TableCell>
                                                                        <TableCell>{rev?.comments ? rev?.comments?.length > 15 ?
                                                                            <Tooltip placement='top' title={rev?.comments}><Typography fontSize={'0.9rem'}>{rev?.comments?.slice(0, 14) + '...'}</Typography></Tooltip> :
                                                                            <Typography fontSize={'0.9rem'}>{rev?.comments}</Typography> : '-'}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </Box></> :
                                                item?.notes_type === 'pain_scale' ?
                                            <><Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Previous Pain Chart</Typography></Box>
                                                <Box component={'div'}>
                                                    <Box component={'div'} sx={{ display: "flex", flexDirection: "row", gap: "0.5vw" }}>
                                                        <Typography fontSize={'0.9vw'} sx={{ color: painLevelTxt[item?.previous_val].color }}>{item?.previous_val ? item?.previous_val : '-'}</Typography>
                                                        <img className='emedhub_pain_range' src={painLevelTxt[item?.previous_val].image} />
                                                        <Typography fontSize={'0.9vw'} sx={{ color: painLevelTxt[item?.previous_val].color }}>{painLevelTxt[item?.previous_val].status}</Typography>
                                                    </Box>
                                                </Box></> :
                                            <Box component={'div'}>
                                                <Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Previous Value</Typography></Box>
                                                <Box display={'flex'} flexWrap={'wrap'}>
                                                        {item?.previous_val ? item?.previous_val?.length > 100 ?
                                                            <Tooltip placement='top'
                                                                interactive
                                                                disableInteractive={false}
                                                                title={
                                                                    <Box
                                                                        sx={{
                                                                            maxHeight: '60vh',
                                                                            overflowY: 'auto',
                                                                            whiteSpace: 'pre-wrap',
                                                                            wordBreak: 'break-word',
                                                                            fontSize: '0.85vw',
                                                                        }}
                                                                    >
                                                                        {item?.previous_val.replace(/<[^>]+>/g, "")}
                                                                    </Box>
                                                                }
                                                                PopperProps={{
                                                                    modifiers: [
                                                                        {
                                                                            name: 'preventOverflow',
                                                                            options: {
                                                                                boundary: 'viewport', // keeps tooltip within screen
                                                                                padding: 8,
                                                                            },
                                                                        },
                                                                        {
                                                                            name: 'flip',
                                                                            options: {
                                                                                fallbackPlacements: ['bottom', 'right', 'left'], // auto adjust if top space is small
                                                                            },
                                                                        },
                                                                    ],
                                                                }}
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            maxWidth: '50vw !important',
                                                                        },
                                                                    },
                                                                }}
                                                                arrow >
                                                            <Typography ml={'0.5rem'} dangerouslySetInnerHTML={{ __html: item?.previous_val?.slice(0, 35) + "..." }} fontSize={'1vw'} />
                                                            </Tooltip> : <Typography ml={'0.5rem'} dangerouslySetInnerHTML={{ __html: item?.previous_val || "-" }} fontSize={'0.9rem'} /> : '-'}
                                                </Box>
                                            </Box>}
                            {/* <Box component={'div'}>
                                <Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Updated Value</Typography></Box>
                                <Box display={'flex'} flexWrap={'wrap'}><Typography ml={'0.5rem'} dangerouslySetInnerHTML={{ __html: item?.updated_val || "-" }} fontSize={'0.9rem'} /></Box>
                            </Box> */}
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const attenderDetails = {
        lineOne: 'Attender Name',
        lineTwo: state.patientDetails?.attender_name || ' -',
        lineFour: 'Contact Number',
        LineFive: state.patientDetails?.attender_mobile || ' -',
    };
    const doctorDetails = {
        lineOne: 'Consultant Name',
        lineTwo: state.patientDetails?.doctor_name || ' -',
    };
    let title = state.SelectedComponent === 'symptoms' ? 'Symptoms' :
        state.SelectedComponent === 'examination' ? 'Examination' :
            state.SelectedComponent === 'diagnosis' ? 'Diagnosis' :
                state.SelectedComponent === 'provisional_diagnosis' ? 'Provisional Diagnosis' :
                    state.SelectedComponent === 'discharge_notes' ? 'Discharge Notes' :
                        state.SelectedComponent === 'family_counselling' ? 'Family Counselling' :
                            state.SelectedComponent === 'medication_instruction' ? 'Medication Instruction' :
                                state.SelectedComponent
    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background }}>
            <Box component={'div'}>
                {/* <Box component={'div'}>
                    <Box display={'flex'} >
                        <Box className='eMed_nur_notes_details eMed_patient_nur_notes'>
                            <CommonPatientDetails data={state.patientDetails} showDetailed={true} />
                        </Box>
                        <CommonPatientCard details={attenderDetails} showDetailed={true} />
                        <ConsultantPatientCard name={doctorDetails} width={"20dvw"} />
                    </Box>
                </Box> */}
                <Box component={'div'} mt={'0.5rem'} height={'63dvh'} p={'0rem 0.5rem'}>
                    <Box className="emed_grid_container_ip">
                        <Card elevation={1} sx={{ overflowY: 'auto', padding: '0.625dvw' }}>{renderMenu()}</Card>
                        <Box className="emed_grid_column" sx={{ padding: "0px", border: state.layoutloading ? "1px solid #ccc" : "none" }}>
                            {state.layoutloading ? (
                                <Box>
                                    {[25, 25, 10].map((h, i) => (
                                        <Skeleton
                                            key={i}
                                            variant="rounded"
                                            animation="wave"
                                            width="97%"
                                            height={`${h}vh`}
                                            sx={{ margin: '1vw' }}
                                        />
                                    ))}
                                </Box>
                            ) : (state.DocNotesLayout?.length > 0 ?
                                state?.DocNotesLayout?.filter(fil => fil?.is_active)?.reduce((acc, item, index) => {
                                    acc.push(
                                        <Box
                                            key={index}
                                            ref={divRefs.current[index]}
                                            onClick={() =>
                                                updateState({
                                                    SelectedComponent: item?.field_name,
                                                    isNewLayout: item?.is_new ? item : {},
                                                })
                                            }
                                        >
                                            {renderComponent(item)}
                                        </Box>
                                    );
                                    return acc;
                                }, []) : renderNOData())}
                        </Box>
                        <Card sx={{ overflowY: 'auto', padding: '0.625dvw' }}>
                            <Box component={'div'} borderBottom={'1px solid lightgray'} pb={'0.5rem'}>
                                <Typography fontWeight={600} fontSize={'0.9rem'} color={Colors.SecondaryText}>History</Typography>
                            </Box>
                            <Box component={'div'} mb={'0.3rem'}><Typography fontSize={'0.9rem'} color={Colors.grayShade}>{state.DocNotesLayout?.find(l => l?.field_name === state.SelectedComponent)?.custom_name || '-'}</Typography></Box>
                            {state.doctorNotesHistory[state.SelectedComponent]?.map((item, index) => {
                                return (<Box key={index} mb={'0.5rem'} visibility={item?.previous_val || item?.exam_data?.length || item?.dia_data?.length || item?.allergy_data?.length || item?.review_data?.length ? 'visible' : 'hidden'}>{renderHistoryDetails(item)}</Box>)
                            })}</Card>
                    </Box>
                </Box>
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default SarasIPDocHome